import { Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useFormContext } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";

export const Discount: React.FC<any> = React.memo((props) => {
  const columns: IColumns[] = [
       
    {
      header: "Amount",
      fieldName: "",
      tooltip: true,
      type: "link",
    },
   
   
  ];
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      <WSDataGrid
              id="discountrewardgrid"
              // title="Order Summary"
              columns={columns}
            /> 
      </Grid>
    </Grid>
  );
});
